import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { globalConst } from "src/app/shared/helpers/constants";
import { BASE_BACKEND, ENDPOINT } from "src/app/shared/http/api";
import { Inventory } from "src/app/shared/models/inventory.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { EtaIndicators } from "./components/report-inventory/report-inventory.component";

@Injectable({
  providedIn: "root",
})
export class ReportService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  getInventory(queryParams): Promise<Inventory[]> {
    const params =
      this.authService.getUserLogged().type !== globalConst.defaults.user.admin
        ? `${queryParams || ""}&userId=${this.authService.getUserLogged().id}`
        : queryParams || "";
    return this.http
      .get(`${BASE_BACKEND}${ENDPOINT.inventory}?${params}`)
      .toPromise()
      .then((data) => data || [])
      .catch((error) => error);
  }

  getEta(queryParams): Promise<Inventory[]> {
    const params =
      this.authService.getUserLogged().type !== globalConst.defaults.user.admin
        ? `${queryParams || ""}&userId=${this.authService.getUserLogged().id}`
        : queryParams || "";
    return this.http
      .get(`${BASE_BACKEND}${ENDPOINT.inventory}eta/?${params}`)
      .toPromise()
      .then((data) => data || [])
      .catch((error) => error);
  }

  getEtaIndicators(queryParams): Promise<EtaIndicators> {
    const params =
      this.authService.getUserLogged().type !== globalConst.defaults.user.admin
        ? `${queryParams || ""}&userId=${this.authService.getUserLogged().id}`
        : queryParams || "";
    return this.http
      .get(`${BASE_BACKEND}${ENDPOINT.inventory}eta-indicators/?${params}`)
      .toPromise()
      .then((data) => data || [])
      .catch((error) => error);
  }

  getInventoryIndicators(queryParams): Promise<EtaIndicators> {
    const params =
      this.authService.getUserLogged().type !== globalConst.defaults.user.admin
        ? `${queryParams || ""}&userId=${this.authService.getUserLogged().id}`
        : queryParams || "";
    return this.http
      .get(`${BASE_BACKEND}${ENDPOINT.inventory}indicators/?${params}`)
      .toPromise()
      .then((data) => data || [])
      .catch((error) => error);
  }

  getAccess(queryParams): Promise<Inventory[]> {
    const params =
      this.authService.getUserLogged().type !== globalConst.defaults.user.admin
        ? `${queryParams || ""}&userId=${this.authService.getUserLogged().id}`
        : queryParams || "";
    return this.http
      .get(`${BASE_BACKEND}user/report/access?${params}`)
      .toPromise()
      .then((data) => data || [])
      .catch((error) => error);
  }
}
